import React, { useState } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  Container, 
  IconButton, 
  Box 
} from '@mui/material';
import { Close } from '@mui/icons-material';

const PrivacyPolicy = ({ open, onClose }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      scroll="paper"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" color="#0d9488">
            Privacy Policy
          </Typography>
          <IconButton onClick={onClose} aria-label="close">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent dividers>
        <Container>
          <Typography variant="h6" gutterBottom>
            1. Information We Collect
          </Typography>
          <Typography paragraph>
            We collect information you provide directly to us, such as when you create an account, 
            use our services, or contact our support team. This may include:
          </Typography>
          <Typography component="ul" gutterBottom>
            <li>Name and contact information</li>
            <li>Company details</li>
            <li>Usage data and analytics</li>
            <li>Payment and billing information</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            2. How We Use Your Information
          </Typography>
          <Typography paragraph>
            We use the information we collect to:
          </Typography>
          <Typography component="ul" gutterBottom>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and send related information</li>
            <li>Send you technical notices, updates, and support messages</li>
            <li>Respond to your comments and questions</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3. Information Sharing
          </Typography>
          <Typography paragraph>
            We do not sell your personal information. We may share information with:
          </Typography>
          <Typography component="ul" gutterBottom>
            <li>Service providers who assist in our operations</li>
            <li>Legal requirements or to protect our rights</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            4. Data Security
          </Typography>
          <Typography paragraph>
            We implement appropriate technical and organizational measures to protect 
            your personal information against unauthorized or unlawful processing, 
            accidental loss, destruction, or damage.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            5. Your Rights
          </Typography>
          <Typography paragraph>
            You have the right to:
          </Typography>
          <Typography component="ul" gutterBottom>
            <li>Access your personal information</li>
            <li>Request correction of your personal information</li>
            <li>Request deletion of your personal information</li>
            <li>Object to processing of your personal information</li>
          </Typography>

          <Typography paragraph sx={{ mt: 3, fontStyle: 'italic' }}>
            Last Updated: March 2024
          </Typography>
        </Container>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyPolicy;